import { useState, useEffect, useCallback } from 'react'
import { apiClient } from '../lib/api'
import { useAuth } from '../contexts/AuthContext'

interface AdminStatus {
  is_admin: boolean
}

interface UpdateUnderlyingResponse {
  success: boolean
  symbol: string
  underlying_ticker: string | null
  underlying_locked: boolean
}

export function useAdmin() {
  const { user } = useAuth()
  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)

  const checkAdminStatus = useCallback(async () => {
    if (!user) {
      setIsAdmin(false)
      setLoading(false)
      return
    }

    try {
      const response = await apiClient.get<AdminStatus>('/admin/status')
      setIsAdmin(response.is_admin)
    } catch {
      setIsAdmin(false)
    } finally {
      setLoading(false)
    }
  }, [user])

  const updateUnderlyingTicker = useCallback(async (
    symbol: string,
    underlyingTicker: string | null
  ): Promise<UpdateUnderlyingResponse> => {
    const response = await apiClient.put<UpdateUnderlyingResponse>(
      `/admin/ticker/${symbol}/underlying`,
      { underlying_ticker: underlyingTicker }
    )
    return response
  }, [])

  useEffect(() => {
    checkAdminStatus()
  }, [checkAdminStatus])

  return {
    isAdmin,
    loading,
    updateUnderlyingTicker,
  }
}
